import { IconsTypesProps } from '../../types';

export const RotorScadaIcon = ({ width = 43, height = 42, fill = '#05B6B2' }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 43 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2343 34.3102C28.7705 34.3102 34.8798 28.3039 34.8798 20.8948C34.8798 13.4857 28.7705 7.47949 21.2343 7.47949C13.6981 7.47949 7.58887 13.4857 7.58887 20.8948C7.58887 28.3039 13.6981 34.3102 21.2343 34.3102Z"
      fill={fill}
    />
    <path
      d="M21.2722 13.2594V1C21.2722 1 16.8899 2.47113 16.7474 7.86528C14.681 8.56582 12.7927 9.72172 11.2607 11.2629"
      fill={fill}
    />
    <path
      d="M21.2722 13.2594V1C21.2722 1 16.8899 2.47113 16.7474 7.86528C14.681 8.56582 12.7927 9.72172 11.2607 11.2629"
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
    <path
      d="M15.7136 15.5706L6.91356 6.91895C6.91356 6.91895 4.88278 10.9821 8.6237 14.9051C7.69738 16.7615 7.23421 18.8281 7.23421 20.8947C7.23421 20.9648 7.23421 20.9998 7.23421 21.0699"
      fill={fill}
    />
    <path
      d="M15.7136 15.5706L6.91356 6.91895C6.91356 6.91895 4.88278 10.9821 8.6237 14.9051C7.69738 16.7615 7.23421 18.8281 7.23421 20.8947C7.23421 20.9648 7.23421 20.9998 7.23421 21.0699"
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
    <path
      d="M13.4688 21.0703H0.999023C0.999023 21.0703 2.49539 25.4137 8.05333 25.5538C8.76589 27.5503 9.97724 29.3717 11.5449 30.8428"
      fill={fill}
    />
    <path
      d="M13.4688 21.0703H0.999023C0.999023 21.0703 2.49539 25.4137 8.05333 25.5538C8.76589 27.5503 9.97724 29.3717 11.5449 30.8428"
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
    <path
      d="M15.8186 26.5342L7.01855 35.1859C7.01855 35.1859 11.2583 37.2174 15.2842 33.3644C17.1369 34.2051 19.1676 34.6604 21.2341 34.6604"
      fill={fill}
    />
    <path
      d="M15.8186 26.5342L7.01855 35.1859C7.01855 35.1859 11.2583 37.2174 15.2842 33.3644C17.1369 34.2051 19.1676 34.6604 21.2341 34.6604"
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
    <path
      d="M21.4121 28.7402V40.9997C21.4121 40.9997 25.9368 39.4935 25.9725 33.8542C27.932 33.1536 29.7134 32.0328 31.1741 30.5967"
      fill={fill}
    />
    <path
      d="M21.4121 28.7402V40.9997C21.4121 40.9997 25.9368 39.4935 25.9725 33.8542C27.932 33.1536 29.7134 32.0328 31.1741 30.5967"
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
    <path
      d="M26.9717 26.4298L35.8074 35.1165C35.8074 35.1165 37.9094 30.8782 33.8835 26.8851C34.8098 25.0287 35.273 22.9621 35.273 20.8955"
      fill={fill}
    />
    <path
      d="M26.9717 26.4298L35.8074 35.1165C35.8074 35.1165 37.9094 30.8782 33.8835 26.8851C34.8098 25.0287 35.273 22.9621 35.273 20.8955"
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
    <path
      d="M26.8651 15.466L35.7008 6.81435C35.7008 6.81435 31.4967 4.78278 27.5064 8.5657C25.5825 7.61997 23.4448 7.1296 21.2715 7.1296"
      fill={fill}
    />
    <path
      d="M26.8651 15.466L35.7008 6.81435C35.7008 6.81435 31.4967 4.78278 27.5064 8.5657C25.5825 7.61997 23.4448 7.1296 21.2715 7.1296"
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
    <path
      d="M21.2366 25.4837C23.8142 25.4837 25.9038 23.4294 25.9038 20.8952C25.9038 18.361 23.8142 16.3066 21.2366 16.3066C18.6589 16.3066 16.5693 18.361 16.5693 20.8952C16.5693 23.4294 18.6589 25.4837 21.2366 25.4837Z"
      fill={fill}
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
    <path
      d="M31.1397 11.1572C32.6717 12.6634 33.8118 14.4498 34.4887 16.4463C40.1536 16.4813 41.6856 20.9297 41.6856 20.9297H29.2158"
      fill={fill}
    />
    <path
      d="M31.1397 11.1572C32.6717 12.6634 33.8118 14.4498 34.4887 16.4463C40.1536 16.4813 41.6856 20.9297 41.6856 20.9297H29.2158"
      stroke="#231F20"
      strokeWidth="0.70054"
      strokeMiterlimit="10"
    />
  </svg>
);
